/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const is = require("is_js");

export const CurrencyConversion = (exchangeRate: any, amount: any) => {
  let res: any = "0";
  if (amount && exchangeRate) {
    res = (amount / exchangeRate).toFixed(2).toString();
  }
  return res;
};
